import { c as _c } from "react/compiler-runtime";
import { useKey } from 'react-use';
import focusAndClick from '../helpers/focusAndClick';
import getFirstFocusableElement from '../helpers/getFirstFocusableElement';
import getFocusableElements from '../helpers/getFocusableElements';
import getLastFocusableElement from '../helpers/getLastFocusableElement';
import isActiveElement from '../helpers/isActiveElement';
import { isEndKey, isHomeKey, isLeftArrowKey, isRightArrowKey } from '../helpers/keys';
const useKeyboardControlForTabs = parentRef => {
  const $ = _c(12);
  let t0;
  if ($[0] !== parentRef) {
    t0 = event => {
      const firstFocusableElement = getFirstFocusableElement(parentRef.current);
      const lastFocusableElement = getLastFocusableElement(parentRef.current);
      const focusableElements = getFocusableElements(parentRef.current);
      if (focusableElements.length && focusableElements.includes(document.activeElement)) {
        event.preventDefault();
        if (firstFocusableElement && isActiveElement(lastFocusableElement)) {
          focusAndClick(firstFocusableElement);
        } else {
          const indexOfCurrentElement = focusableElements.findIndex(isActiveElement);
          const nextElement = focusableElements[indexOfCurrentElement + 1];
          if (nextElement) {
            focusAndClick(nextElement);
          }
        }
      }
    };
    $[0] = parentRef;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      event: "keydown"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useKey(isRightArrowKey, t0, t1);
  let t2;
  if ($[3] !== parentRef) {
    t2 = event_0 => {
      const firstFocusableElement_0 = getFirstFocusableElement(parentRef.current);
      const lastFocusableElement_0 = getLastFocusableElement(parentRef.current);
      const focusableElements_0 = getFocusableElements(parentRef.current);
      if (focusableElements_0.length && focusableElements_0.includes(document.activeElement)) {
        event_0.preventDefault();
        if (lastFocusableElement_0 && isActiveElement(firstFocusableElement_0)) {
          focusAndClick(lastFocusableElement_0);
        } else {
          const indexOfCurrentElement_0 = focusableElements_0.findIndex(isActiveElement);
          const prevElement = focusableElements_0[indexOfCurrentElement_0 - 1];
          if (prevElement) {
            focusAndClick(prevElement);
          }
        }
      }
    };
    $[3] = parentRef;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      event: "keydown"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useKey(isLeftArrowKey, t2, t3);
  let t4;
  if ($[6] !== parentRef) {
    t4 = event_1 => {
      const firstFocusableElement_1 = getFirstFocusableElement(parentRef.current);
      const focusableElements_1 = getFocusableElements(parentRef.current);
      if (focusableElements_1.length && focusableElements_1.includes(document.activeElement)) {
        event_1.preventDefault();
        if (firstFocusableElement_1 && !isActiveElement(firstFocusableElement_1)) {
          focusAndClick(firstFocusableElement_1);
        }
      }
    };
    $[6] = parentRef;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      event: "keydown"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useKey(isHomeKey, t4, t5);
  let t6;
  if ($[9] !== parentRef) {
    t6 = event_2 => {
      const lastFocusableElement_1 = getLastFocusableElement(parentRef.current);
      const focusableElements_2 = getFocusableElements(parentRef.current);
      if (focusableElements_2.length && focusableElements_2.includes(document.activeElement)) {
        event_2.preventDefault();
        if (lastFocusableElement_1 && !isActiveElement(lastFocusableElement_1)) {
          focusAndClick(lastFocusableElement_1);
        }
      }
    };
    $[9] = parentRef;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      event: "keydown"
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  useKey(isEndKey, t6, t7);
};
export default useKeyboardControlForTabs;